export default __webpack_public_path__ + "static/media/default.625b374444f9259a533a271930fba096.svg";